import { useContext } from "react";
import { LanguageContext } from "../../../store/language-context";

export default function MultiLanTxt({ tid }) {
  const languageContext = useContext(LanguageContext);

  return languageContext.dictionary[tid] || tid;
}
